<template>
  <p
    v-if="!changes.length"
    class="text-medium-emphasis"
    data-testid="feature-changes-empty"
  >
    No changes recorded yet.
  </p>
  <ol v-else class="feature-changes" data-testid="feature-changes-list">
    <li
      v-for="change in changes"
      :key="change.id"
      class="feature-change"
      data-testid="feature-change"
    >
      <div class="feature-change__meta">
        <strong v-if="showFeatureName" data-testid="feature-change-name">
          {{ change.featureName }}
        </strong>
        <span>{{ change.changedAt.format("DD MMM YYYY HH:mm") }}</span>
        <SoChip
          :text="operationLabel(change.operation)"
          size="small"
          data-testid="feature-change-operation"
        />
      </div>
      <ul class="feature-change__fields">
        <li
          v-for="field in change.changes"
          :key="field.field"
          data-testid="feature-change-field"
        >
          {{ describeFieldChange(field) }}
          <div
            v-if="isTextFieldChange(field)"
            class="feature-change__text"
            data-testid="feature-change-text"
          >
            <del v-if="field.oldValue">{{ field.oldValue }}</del>
            <ins v-if="field.newValue">{{ field.newValue }}</ins>
          </div>
        </li>
      </ul>
    </li>
  </ol>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import { IFeatureChange } from "@/models/admin/featureChange/featureChange.types"
  import {
    describeFieldChange,
    isTextFieldChange,
    operationLabel,
  } from "@/models/admin/featureChange/describeFieldChange"

  export default defineComponent({
    components: { SoChip },
    props: {
      changes: {
        type: Array as PropType<IFeatureChange[]>,
        required: true,
      },
      showFeatureName: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      describeFieldChange,
      isTextFieldChange,
      operationLabel,
    },
  })
</script>

<style scoped>
  .feature-changes {
    list-style: none;
    padding: 0;
  }

  .feature-change {
    padding-block: 0.75rem;
    border-bottom: 1px solid
      rgba(var(--v-border-color), var(--v-border-opacity));
  }

  .feature-change__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
  }

  .feature-change__fields {
    margin-top: 0.25rem;
    padding-left: 1.25rem;
  }

  .feature-change__text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-top: 0.25rem;
    white-space: normal;
    overflow-wrap: anywhere;
  }
</style>
